<template>
  <ion-page>
    <master-layout pageTitle="<i class='fal fa-shopping-cart'></i>&nbsp; سبد خرید">
      <Loading :is="!cartLoaded" v-if="!cartLoaded"></Loading>
      <div class="cart-div">
      <div v-if="cartLoaded">
        <div v-if="cart_items.length">
        <cart-item ref="cartItem" @itemChanged="(v)=>{setItem(v,index)}"
                   @del_items="delItem(index)"
                   :item="item"
                   v-for="(item,index) in cart_items" :key="index">
        </cart-item>
        <ion-card>
          <ion-card-contetn>
            <div class="content-between">
              <div>جمع کل خرید شما : </div>
              <div>
                <money :number="original_total"></money>
                تومان
                </div>
            </div>
            <div class="content-between text-success">
              <div>مبلغ قابل پرداخت : </div>
              <div>
                <money :number="total"></money>
                تومان
              </div>
            </div>
            <div class="content-between text-danger">
              <div>سود شما : </div>
              <div>
                  <money :number="special_discount"></money>
                  تومان
                </div>
            </div>
          </ion-card-contetn>
        </ion-card>
        </div>
        <ion-card v-else class="center">
          <ion-card-contetn>
          <img class="img" src="/assets/img/cart-empty.webp" alt="cartEmpty">
          <h5 class="text-danger center"><i class="fas fa-shopping-basket"></i>&nbsp;سبد خرید شما خالی می باشد.</h5>
          </ion-card-contetn>
        </ion-card>

      </div>
      <div v-if="error" class="alert alert-danger">
        {{ error }}
      </div>
      </div>

    </master-layout>
    <ion-button @click="goShipping()" v-if="cartLoaded && cart_items.length" class="add-btn" color="success" expand="full" size="large">تایید وادامه فرایند خرید</ion-button>
  </ion-page>
</template>

<script>
import {IonGrid, IonRow, IonCol, IonPage,IonImg} from '@ionic/vue'
import {mapActions} from "vuex";
import Money from "@/components/Money";
import cartItem from "@/components/cartItem";

/**
 * ToDo:
 *  sibling categories on top
 *  top banner on first page
 *  cat title on top of page
 */
export default {
  name: "categories",
  data: function ()
  {
    return {
      id: null,
      cartLoaded: false,
      cart_items : [],
      original_total : 0,
      total : 0,
      special_discount : 0,
      error: null,
      wait_btn : false,
    }
  },
  async created()
  {
    await this.init();
  },
  mounted()
  {

  },
  methods: {
    async init()
    {
      const result = await this.getCartItems();
      if (result)
      {
        if (result.ok)
        {
          this.cartLoaded = true;
          this.cart_items = result.items;
          await this.calculateTotal();
        }
        else
        {
          this.cartLoaded = true;
          this.error = result.error
        }
      }
      else
      {
        this.cartLoaded = true;
        this.error = 'خطا در برقراری ارتباط با سرور'
      }
    },
    ...mapActions("shop", {
      getCartItems: 'getCartItems',
      checkCartItems : 'checkCartItems'
    }),
    setItem(newItem,index)
    {
      this.cart_items[index] = newItem;
      this.calculateTotal();
    },
    calculateTotal()
    {
      const items = this.cart_items;
      let total = 0;
      let original_total = 0;
      let special_discount = 0;
      for (let i = 0; i < items.length; i++)
      {
        total += items[i].total;
        special_discount += items[i].special_discount;
        original_total += items[i].quantity * items[i].original_price;
      }
      this.total = total;
      this.original_total = original_total;
      this.special_discount = special_discount;
    },
    async goShipping()
    {
      const self = this;
     const check = await this.checkCartItems();
     if (check.ok)
     {
       if (check.error)
         await this.init();
       else
       {
         self.$router.push({path : '/Shipping'})
       }

     }
    },
    delItem(index)
    {
      this.cart_items.splice(index,1);
      this.calculateTotal();
    }

  },
  components: {
    Money,
    cartItem,
    IonGrid, IonRow, IonCol, IonPage,IonImg
  },
  props:{
    default:null
  },
  watch: {
    "$route.path": {
      handler(newUrl)
      {
        if (newUrl.toLowerCase().indexOf('shopcart') >= 0)
        {
          this.cartLoaded = true;
          this.init()
        }
      },
      deep:true
    },
  }
}
</script>

<style scoped>
.content-between
{
  display: flex;
  justify-content: space-between;
  padding: 8px;
  border-bottom: 1px solid silver;
}
.img
{
  width: 200px;
  margin: 20px auto;
}

.add-btn
{
  position: absolute;
  bottom: 56px;
  width: 99%;
}
.cart-div
{
  padding-bottom: 56px;
}

</style>